export const addReportJob = (job) => ({
  type: 'ADD_REPORT_JOB',
  payload: job,
});

export const updateReportJob = (id, updates) => ({
  type: 'UPDATE_REPORT_JOB',
  payload: { id, updates },
});

export const removeReportJob = (id) => ({
  type: 'REMOVE_REPORT_JOB',
  payload: id,
});
